




import { Component, Vue, Prop, Watch } from "vue-property-decorator";

import {
  Instrument,
  INoteValue,
  NoteValue,
  IInstrumentSettings
} from "piano-chart";

let instrument: Instrument;

@Component
export default class InstrumentContainer extends Vue {
  currentOctave = 3;

  _pressedKeys: NoteValue[] = [];
  @Prop() public pressedKeys!: NoteValue[];

  @Prop() public instrumentSettings!: IInstrumentSettings;

  mounted() {
    this.showPiano();
    this.addMouseListeners();
  }

  @Watch("pressedKeys")
  handlePressedKeys(newKeys: NoteValue[]) {
    newKeys.forEach(nk => {
      if (this.$data._pressedKeys.indexOf(nk) < 0) {
        instrument.keyDown(nk);
      }
    });
    this.$data._pressedKeys.forEach((pk: NoteValue) => {
      if (newKeys.indexOf(pk) < 0) {
        instrument.keyUp(pk);
      }
    });
    this.$data._pressedKeys.splice(0);
    this.$data._pressedKeys.push(...newKeys);
  }

  @Watch("instrumentSettings", { deep: true })
  applyInstrumentSettings(newSettings: IInstrumentSettings) {
    instrument.applySettings(newSettings);
  }

  beforeDestroy() {
    this.removeMouseListeners();
    instrument.destroy();
  }

  showPiano() {
    instrument = new Instrument(
      this.$refs.instrumentParent as HTMLElement,
      this.instrumentSettings
    );
    instrument.create();
  }

  addMouseListeners() {
    instrument.addKeyMouseDownListener(this.keyMouseDown);
    instrument.addKeyMouseUpListener(this.keyMouseUp);
  }

  removeMouseListeners() {
    instrument.removeKeyMouseDownListener(this.keyMouseDown);
    instrument.removeKeyMouseUpListener(this.keyMouseUp);
  }

  keyMouseDown(note: INoteValue) {
    this.$emit("note-down", note);
  }
  keyMouseUp(note: INoteValue) {
    this.$emit("note-up", note);
  }

  takeScreenshot(signature?: string) {
    instrument.rasterize(this.screenshotCallback, signature);
  }
  screenshotCallback(dataUrl: string) {
    this.$emit("screenshot-taken", dataUrl);
  }
}
